// extracted by mini-css-extract-plugin
export default {"tooltipDropdown":"MiniTooltip_tooltipDropdown__F9GFw"};